import React, { useState, useEffect } from 'react'
import {
  ButtonWrapper,
  LinkToLoginContainer,
  OverlayShadow,
  ToLoginContainer,
  WelcomeContainer,
  WelcomeContent,
  WelcomeDescription,
  WelcomeSubTitle,
  WelcomeTitle,
} from './style'
import { ESignupForms } from '../../../../types/enums/ESignupForms'
import { ISignupStepProps } from '../../../../types/interfaces/ISignupStepProps'
import { SignupTexts } from '../../../../constants/signup-texts'
import { Loader } from '../../../../shared/components/loader/loader'
import { Link } from 'react-router-dom'
import { EAppRoutes } from 'types/enums/EAppRoutes'
import { mhfcAuthApiSlice } from 'store/apiSlice'
import { userLogout } from 'store/reducers/userReducer'
import { useAppDispatch } from 'store/store'
import { cookieService } from 'services/cookie.service'

export const WelcomePage: React.FC<ISignupStepProps> = ({ callback }) => {
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useAppDispatch()

  const clearAllData = async () => {
    try {
      const cacheNames = await caches.keys()
      await Promise.all(cacheNames.map((name) => caches.delete(name)))
      dispatch(mhfcAuthApiSlice.util.resetApiState())
      dispatch(userLogout())
      localStorage.clear()
      sessionStorage.clear()
      cookieService.deleteAllCookies()

      document.cookie.split(';').forEach((cookie) => {
        const [name] = cookie.split('=')
        document.cookie = `${name.trim()}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
      })

      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations()
        await Promise.all(
          registrations.map((registration) => registration.unregister()),
        )
      }
    } catch (error) {
      console.error('Error clearing browser data:', error)
    }
  }
  useEffect(() => {
    clearAllData()
  }, [])
  return isLoading ? (
    <Loader />
  ) : (
    <WelcomeContainer>
      <OverlayShadow />
      <WelcomeContent>
        <WelcomeTitle>{SignupTexts.Welcome}</WelcomeTitle>
        <WelcomeSubTitle>{SignupTexts.YayNewWebsiteMounted}</WelcomeSubTitle>
        <WelcomeDescription>
          {SignupTexts.InOrderToGiveTheBestExperiencePleaseFillCertainDetails}
          <br />
          <br />
          {SignupTexts.ShallWeBegin}
        </WelcomeDescription>
      </WelcomeContent>
      <ButtonWrapper
        type="submit"
        className="buttonWrapper"
        text={SignupTexts.ToRegister}
        callback={() => {
          setIsLoading(true)
          callback(ESignupForms.signupForm)
          setIsLoading(false)
        }}
      />
      <ToLoginContainer>
        {SignupTexts.AlreadyAUser}
        <LinkToLoginContainer>
          <Link style={{ zIndex: '2' }} to={EAppRoutes.LOGIN}>
            {SignupTexts.ToLogIn}
          </Link>
        </LinkToLoginContainer>
      </ToLoginContainer>
    </WelcomeContainer>
  )
}
